import React from 'react';
import {
  Box,
  FlexBox,
  InputIncrementer,
  Label
} from '@directsoftware/ui-kit-web-admin';
import { useSelector } from 'react-redux';
import { selectListingsSearchState } from '../../../redux/slices/listingsSearch';

const ListingsSearchNumBeds = ({ updateSearchState, translate }) => {
  const searchState = useSelector(selectListingsSearchState);

  return (
    <FlexBox alignItems="center" justifyContent="space-between">
      <Box flex="1">
        <Label>{translate('cx.global.amenities.bedrooms')}</Label>
      </Box>
      <Box>
        <InputIncrementer
          onChange={num => updateSearchState({ filter_numBedrooms: num }, true)}
          value={searchState.filter_numBedrooms}
          inputWidth="s"
          min={0}
          max={searchState.maxBedrooms}
          isDense
          removeBottomSpacer
        />
      </Box>
    </FlexBox>
  );
};

export default ListingsSearchNumBeds;
